module.exports = __webpack_public_path__ + "static/media/image_15.3301a261.png";